import styled from 'styled-components';

export const ContentWrapper = styled.div`
  background-color: white;
  width: 100%;
  box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
  border-radius: 10px;
  max-width: 800px;
  
  max-height: 100vh;
  overflow: auto;
`;
